import React from "react";

const Chapter08 = () => {
    return (
        <div className="page-padd">
            <center>
                <iframe
                    src="./chapter08.html"
                    title="HTML File"
                    width="100%"
                    height="800px"
                    style={{ border: "none" }}
                />
            </center>
        </div>
    );
}

export default Chapter08;